import { object, string, bool } from 'yup'
import { gql, useQuery } from '@apollo/client'
import client from 'apollo-client'
import { CIVILITIES } from './constants'
import { serializeContact } from './utils'

const OPERATION_IS_LOCKED = gql`
    query IsLockedContact($sf_id: ID!) {
        locked: isLockedContact(sf_id: $sf_id)

    }
`
const OPERATION_UPDATE = gql`
    mutation UpdateContact($sf_id: String!, $center_user_id: String, $confirm: Boolean, $contact: InputContact!) {
        contact: updateContact(sf_id: $sf_id, center_user_id: $center_user_id, confirm: $confirm, contact: $contact) {
            sf_id
            center_user_id
        }
    }
`

const OPERATION_CREATE = gql`
    mutation CreateContact($confirm: Boolean, $contact: InputContact!) {
        contact: createContact(confirm: $confirm, contact: $contact) {
            sf_id
            center_user_id
        }
    }
`

export const buildSchema = ({t}) => {
  return object({
    internal: bool(),
    salutation: string()
      .nullable()
      .when(['internal'], {
        is: (v) => !v,
        then: (schema) => schema.oneOf(CIVILITIES.map(({ value }) => value)),
        otherwise: (schema) => schema.notRequired(),
      }),
    last_name: string()
      .nullable()
      .when(['internal'], {
        is: (v) => !v,
        then: (schema) => (schema.required(t('ui_elements.required_field'))),
        otherwise: (schema) => schema.notRequired(),
      }),
    first_name: string()
      .nullable()
      .when(['internal'], {
        is: (v) => !v,
        then: (schema) => (schema.required(t('ui_elements.required_field'))),
        otherwise: (schema) => schema.notRequired(),
      }),
    email: string().email().required(t('ui_elements.required_field')),
    title: string()
      .nullable()
      .when(['internal'], {
        is: (v) => !v,
        then: (schema) => (schema.required(t('ui_elements.required_field'))),
        otherwise: (schema) => schema.notRequired(),
      }),
    langue: string()
      .nullable()
      .when(['internal'], {
        is: (v) => !v,
        then: (schema) => schema.required(t('ui_elements.required_field')),
        otherwise: (schema) => schema.notRequired(),
      }),
    country: string()
      .nullable()
      .when(['internal'], {
        is: (v) => !v,
        then: (schema) => (schema.required(t('ui_elements.required_field'))),
        otherwise: (schema) => schema.notRequired(),
      }),
    mobile_phone: string()
      .nullable()
      .matches(/^\+?[\s0-9]*$/, 'Veuillez rentrer des numéros'),
    phone: string()
      .nullable()
      .matches(/^\+?[\s0-9]*$/, 'Veuillez rentrer des numéros')
  })
}


export const useIsLocked = ({sfId}) => {
  const {data} = useQuery(OPERATION_IS_LOCKED, {
    variables: {
      sf_id: sfId
    },
    skip: !sfId,
    pollInterval: 1000
  })

  return data ? data.locked : false
}
const useSave = () => {
  const saveContact = async ({sf_id, center_user_id, confirm, contact}) => {
    let response
    if (sf_id) {
      response = await client.mutate({
        mutation: OPERATION_UPDATE,
        variables: {
          sf_id,
          center_user_id,
          contact,
          confirm
        }
      })
    } else {
      response = await client.mutate({
        mutation: OPERATION_CREATE,
        variables: {
          contact,
          confirm
        }
      })
    }

    return response.data.contact
  }

  const save = async (contact) => {
    const { sf_id, center_user_id, confirm, ...serializedContact } = serializeContact(contact)
    return saveContact({sf_id, center_user_id, confirm, contact: serializedContact})
  }
  return save
}

export default useSave
